(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6580],{

/***/ 1293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5467);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6896);
/* harmony import */ var _src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6543);
/* harmony import */ var _src_components_Home_Blogs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1600);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);







var BlogsPage = function BlogsPage(_ref) {
  var _seoData$title, _seoData$title2, _seoData$description, _seoData$keywords;

  var blogsData = _ref.blogsData,
      seoData = _ref.seoData,
      noindex = _ref.noindex;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    children: [((seoData === null || seoData === void 0 ? void 0 : (_seoData$title = seoData.title) === null || _seoData$title === void 0 ? void 0 : _seoData$title[locale]) || noindex) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_1__["default"], {
      title: seoData === null || seoData === void 0 ? void 0 : (_seoData$title2 = seoData.title) === null || _seoData$title2 === void 0 ? void 0 : _seoData$title2[locale],
      description: seoData === null || seoData === void 0 ? void 0 : (_seoData$description = seoData.description) === null || _seoData$description === void 0 ? void 0 : _seoData$description[locale],
      keywords: seoData === null || seoData === void 0 ? void 0 : (_seoData$keywords = seoData.keywords) === null || _seoData$keywords === void 0 ? void 0 : _seoData$keywords[locale],
      noindex: noindex
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_0__["default"], {
      heading: "".concat(formatMessage({
        id: "blog"
      }), " -  ").concat(formatMessage({
        id: "categories"
      })),
      description: "".concat(formatMessage({
        id: "main"
      }), " / ").concat(formatMessage({
        id: "blog"
      }), " / ").concat(formatMessage({
        id: "categories"
      })),
      background: blogsData === null || blogsData === void 0 ? void 0 : blogsData.breadCurmbImage
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "row",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "info"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_components_Home_Blogs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      blogs: blogsData === null || blogsData === void 0 ? void 0 : blogsData.items
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogsPage);

/***/ }),

/***/ 276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/category/[id]",
      function () {
        return __webpack_require__(1293);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,2143,1664,5242,9774,2888,179], function() { return __webpack_exec__(276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);